module.exports = __webpack_public_path__ + "static/img/78035A_2_C_20200210_LC.43c888f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78035A_2_C_20200210_LC.png
// module id = 92VN
// module chunks = 0